import React, { useState, useMemo } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
  Typography,
} from '@mui/material';
import { SearchInput } from '../SearchInput';

const SearchBarDropdown = ({
  value,
  options,
  onChange,
  label = 'Select Option',
  disabled = false,
  sx = {},
  message = 'Select an option',
  onOpen = () => { },
  MenuProps: customMenuProps = {},
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter options based on search term
  const filteredOptions = useMemo(() => {
    if (!searchTerm) return options;
    return options.filter((option) =>
      String(option).toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [options, searchTerm]);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    console.log('SearchBarDropdown - Selected value:', selectedValue);
    onChange(selectedValue);
  };

  const handleOpen = () => {
    setSearchTerm('');
    onOpen();
  };

  const handleClose = () => {
    setSearchTerm('');
  };

  return (
    <FormControl fullWidth sx={{ ...sx }}>
      <InputLabel id='search-bar-dropdown-label' shrink={!value ? true : undefined}>{label}</InputLabel>
      <Select
        labelId='search-bar-dropdown-label'
        id='search-bar-dropdown'
        value={value}
        label={label}
        onChange={handleChange}
        disabled={disabled}
        displayEmpty
        notched={!value ? true : undefined}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography sx={{ color: 'text.secondary' }}>
                {message}
              </Typography>
            );
          }
          return <Typography>{selected}</Typography>;
        }}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 300, zIndex: 1600 },
          },
          autoFocus: false,
          disablePortal: true,
          ...customMenuProps,
        }}
        onOpen={handleOpen}
        onClose={handleClose}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--clr-theme-purple)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--clr-theme-purple)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--clr-theme-purple)',
          },
        }}
      >
        {/* Search bar inside dropdown */}
        <ListSubheader
          disableSticky
          onMouseDown={(e) => e.stopPropagation()}
        >
          <SearchInput
            value={searchTerm}
            onChange={setSearchTerm}
            message='Search...'
          />
        </ListSubheader>

        {/* Render filtered options */}
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            <Typography sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
              No options found
            </Typography>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default SearchBarDropdown;